import React, { useState } from "react";

const portfolioItems = [
  // ===== Building Materials =====
  // { id: 1, category: "building", image: "/assets/img/portfolio/bbm-1.webp" },
  { id: 2, category: "building", image: "/assets/img/portfolio/bbm-2.webp" },
  // { id: 3, category: "building", image: "/assets/img/portfolio/bbm-3.webp" },
  { id: 4, category: "building", image: "/assets/img/portfolio/bbm-4.webp" },
  { id: 5, category: "building", image: "/assets/img/portfolio/bbm-5.webp" },
  { id: 6, category: "building", image: "/assets/img/portfolio/bbm-6.webp" },
  { id: 7, category: "building", image: "/assets/img/portfolio/bbm-7.webp" },
  { id: 8, category: "building", image: "/assets/img/portfolio/bbm-8.webp" },
  { id: 9, category: "building", image: "/assets/img/portfolio/bbm-9.webp" },
  { id: 10, category: "building", image: "/assets/img/portfolio/bbm-a.webp" },

  // ===== Catering =====
  { id: 11, category: "catering", image: "/assets/img/portfolio/catering-1.webp" },
  // { id: 12, category: "catering", image: "/assets/img/portfolio/catering-2.webp" },
  // { id: 13, category: "catering", image: "/assets/img/portfolio/catering-3.webp" },
  // { id: 14, category: "catering", image: "/assets/img/portfolio/catering-4.webp" },
  { id: 15, category: "catering", image: "/assets/img/portfolio/catering-5.webp" },
  // { id: 16, category: "catering", image: "/assets/img/portfolio/catering-7.webp" },
  { id: 17, category: "catering", image: "/assets/img/portfolio/catering-8.webp" },
  // { id: 18, category: "catering", image: "/assets/img/portfolio/catering-9.webp" },
  { id: 19, category: "catering", image: "/assets/img/portfolio/catering-b.webp" },
  { id: 20, category: "catering", image: "/assets/img/portfolio/catering-d.webp" },
  // { id: 21, category: "catering", image: "/assets/img/portfolio/catering-g.webp" },
  { id: 22, category: "catering", image: "/assets/img/portfolio/catering-h.webp" },

  // ===== Hotels =====
  { id: 23, category: "hotel", image: "/assets/img/portfolio/hotel-1.webp" },
  // { id: 24, category: "hotel", image: "/assets/img/portfolio/hotel-2.webp" },
  { id: 25, category: "hotel", image: "/assets/img/portfolio/hotel-3.webp" },
  { id: 26, category: "hotel", image: "/assets/img/portfolio/hotel-4.webp" },
  { id: 27, category: "hotel", image: "/assets/img/portfolio/hotel-5.webp" },
  // { id: 28, category: "hotel", image: "/assets/img/portfolio/hotel-6.webp" },
  { id: 29, category: "hotel", image: "/assets/img/portfolio/hotel-7.webp" },
  { id: 30, category: "hotel", image: "/assets/img/portfolio/hotel-8.webp" },
  { id: 31, category: "hotel", image: "/assets/img/portfolio/hotel-9.webp" },
  { id: 32, category: "hotel", image: "/assets/img/portfolio/hotel-a.webp" },
  { id: 33, category: "hotel", image: "/assets/img/portfolio/hotel-b.webp" },
  { id: 34, category: "hotel", image: "/assets/img/portfolio/hotel-c.webp" },
  { id: 35, category: "hotel", image: "/assets/img/portfolio/hotel-d.webp" },
  // { id: 36, category: "hotel", image: "/assets/img/portfolio/hotel-e.webp" },

  // ===== MPC Plastics =====
  { id: 37, category: "plastic", image: "/assets/img/portfolio/plastic-1.webp" },

  //===== IT Solutions =====
   { id: 38, category: "it", image: "/assets/img/portfolio/it-1.webp" },
   { id: 39, category: "it", image: "/assets/img/portfolio/it-2.webp" },
   { id: 40, category: "it", image: "/assets/img/portfolio/it-3.webp" },
   { id: 41, category: "it", image: "/assets/img/portfolio/it-4.webp" },
   { id: 42, category: "it", image: "/assets/img/portfolio/it-5.webp" },
   { id: 43, category: "it", image: "/assets/img/portfolio/it-6.webp" },
  
];

function Portfolio() {
  const [filter, setFilter] = useState("all");

  const filteredItems =
    filter === "all"
      ? portfolioItems
      : portfolioItems.filter((item) => item.category === filter);

  return (
    <section id="portfolio" className="portfolio section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Portfolio</h2>
        <p>
          A glimpse into our diverse projects across industries — where vision
          meets execution
        </p>
      </div>

      <div className="container">
        <ul
          className="portfolio-filters"
          data-aos="fade-up"
          data-aos-delay={100}
        >
          {[
            { key: "all", label: "All" },
            { key: "hotel", label: "Hotel" },
            { key: "catering", label: "Catering" },
            { key: "building", label: "Building Materials" },
            { key: "it", label: "IT Solutions" },
            { key: "plastic", label: "MPC Plastics" },
          ].map((cat) => (
            <li
              key={cat.key}
              className={filter === cat.key ? "filter-active" : ""}
              onClick={() => setFilter(cat.key)}
              style={{
                cursor: "pointer",
                display: "inline-block",
                marginRight: "15px",
              }}
            >
              {cat.label}
            </li>
          ))}
        </ul>

        <div className="row gy-4" data-aos="fade-up" data-aos-delay={200}>
          {filteredItems.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 portfolio-item">
              <img
                src={item.image}
                alt="Portfolio"
                className="img-fluid"
                loading="lazy"
                decoding="async"
                width="600"
                height="400"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
